import { FC, useState, useEffect } from 'react'

import styles from './countdown.module.scss'

interface ICountDown {
  hours: number
  minutes: number
  seconds: number
  refToggle?: any
  refReset?: any
  onEnd?: () => void
}

const CountDown: FC<ICountDown> = ({
  hours = 0,
  minutes = 0,
  seconds = 0,
  refToggle,
  refReset,
  onEnd,
}: ICountDown) => {
  const [paused, setPaused] = useState(true)
  const [over, setOver] = useState(false)
  const [[h, m, s], setTime] = useState([hours, minutes, seconds])

  const tick = () => {
    if (paused || over) {
      onEnd?.()
      return
    }

    if (h === 0 && m === 0 && s === 0) {
      setOver(true)
    } else if (m === 0 && s === 0) {
      setTime([h - 1, 59, 59])
    } else if (s == 0) {
      setTime([h, m - 1, 59])
    } else {
      setTime([h, m, s - 1])
    }
  }

  const reset = () => {
    setTime([hours, minutes, seconds])
    setPaused(false)
    setOver(false)
  }

  const toggle = () => {
    setPaused((prev) => !prev)
  }

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000)
    return () => clearInterval(timerID)
  })

  useEffect(() => {
    if (refReset) refReset.current = reset
    if (refToggle) refToggle.current = toggle
  }, [refReset, refToggle])

  return (
    <div>
      <div className={styles.timer}>
        {!!h && <p>{`${h.toString().padStart(2, '0')}:`}</p>}
        <p>{`${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`}</p>
      </div>
    </div>
  )
}

export default CountDown
